import { MemberApi } from '@common/api/member';
import { i18n } from 'next-i18next';
import { Api } from './request';
export default ({ areaCode, phone }) => {
    return new Promise((resolve) => {
        MemberApi.checkMobile({
            phone,
            areaCode
        }, { hideLoading: true })
            .then(({ code, message }) => {
            switch (code) {
                case 1:
                    // 未注册
                    resolve({
                        type: 'notRegister',
                        message: (i18n === null || i18n === void 0 ? void 0 : i18n.t('common:login.phoneStatusTips.notRegister')) || message
                    });
                    break;
                case 5:
                    // 已冻结
                    resolve({
                        type: 'frozen',
                        message: (i18n === null || i18n === void 0 ? void 0 : i18n.t('common:login.phoneStatusTips.frozen')) || message
                    });
                    break;
                case 6:
                    // 已注册
                    resolve({
                        type: 'registered',
                        message: (i18n === null || i18n === void 0 ? void 0 : i18n.t('common:login.phoneStatusTips.registered')) || message
                    });
                    break;
                default:
                    // 错误提示
                    resolve({ type: 'error', message });
                    break;
            }
        })
            .catch((e) => {
            // 错误提示
            resolve({ type: 'error', message: e.data.errMsg });
            Api.errorHandle(e);
        });
    });
};
